__turbopack_context__.v({
  "anyZone": "cardZones-module-scss-module__jxrrtW__anyZone",
  "commander": "cardZones-module-scss-module__jxrrtW__commander",
  "or": "cardZones-module-scss-module__jxrrtW__or",
  "symbol": "cardZones-module-scss-module__jxrrtW__symbol",
  "zones": "cardZones-module-scss-module__jxrrtW__zones",
});
